import { Map } from 'immutable'

export const INITIAL_STATE = Map({
  createTicketIsLoading: false,
  createTicketErrorMessage: null,
  // Dialog
  isSupportFormDialogOpened: false,
})
